import { InfoList } from 'o2o_layout';
import React from 'react';
import { useManageLogs } from '../contexts/manage-logs.context';

const TableRefresherPrivacyLogs = () => {
  const { searchPlatformTermUser } = useManageLogs();

  return (
    <InfoList
      list={searchPlatformTermUser?.response}
      loading={searchPlatformTermUser.isLoading}
      refresh={searchPlatformTermUser.onRetry}
    />
  );
};

export default TableRefresherPrivacyLogs;
